// init as external plugin
window.KolesoWidgetAdmin = {
  init: ({ token, uuid, login }) => {
    ;(function (w, d, widget, link, script, p) {
      // widget env
      const widgetURL = process.env.VUE_APP_URL
      // widget create
      widget = d.createElement("koleso-admin-widget")
      widget.setAttribute("token", token)
      widget.setAttribute("uuid", uuid)
      widget.setAttribute("login", login)
      // widget style add
      d.getElementsByTagName("body")[0].appendChild(widget)
      link = d.createElement("link")
      link.rel = "stylesheet"
      link.href = widgetURL + "/css/index.css?" + process.env.VUE_APP_VER
      d.getElementsByTagName("head")[0].appendChild(link)
      // widget script add
      script = d.createElement("script")
      script.async = true
      script.src = widgetURL + "/js/index.js?" + process.env.VUE_APP_VER
      d.getElementsByTagName("body")[0].appendChild(script)
    })(window, document)
  },
}
